import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from '@/kenya_friars_components/links';
import { Button } from '@/kenya_friars_components/buttons';
import { FaTimes } from 'react-icons/fa';
import missionImage from '@/assets/images/home_mission.jpeg';
import '@/styles/modals.css';
import './DonationPopup.css';

const DELAY_MS = 5000;

export const DonationPopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { pathname } = useLocation();

  // Run once on mount (and thus again after every full page refresh). Skip on admin routes.
  useEffect(() => {
    if (pathname.startsWith('/admin')) return;

    const timer = window.setTimeout(() => {
      setIsVisible(true);
    }, DELAY_MS);

    return () => window.clearTimeout(timer);
    // Intentionally only on mount: we want one popup per visit/refresh, using pathname at load time.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const close = () => setIsVisible(false);

  // Prevent background from scrolling while popup is open
  useEffect(() => {
    if (!isVisible) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div
      className="kf-modal__overlay kf-donation-popup__overlay"
      onClick={(e) => e.target === e.currentTarget && close()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="donation-popup-title"
    >
      <div className="kf-donation-popup">
        <button
          type="button"
          className="kf-modal__close kf-donation-popup__close"
          onClick={close}
          aria-label="Close"
        >
          <FaTimes />
        </button>

        <div className="kf-donation-popup__inner">
          <div className="kf-donation-popup__image-wrap">
            <img
              src={missionImage}
              alt="Our Mission & Vision"
              className="kf-donation-popup__image"
            />
          </div>
          <div className="kf-donation-popup__content">
            <div className="kf-donation-popup__logo">
              <img src="/CONVKENYA_Transparent.png" alt="Kenya Friars" className="kf-donation-popup__logo-img" />
            </div>
            <h2 id="donation-popup-title" className="kf-donation-popup__title">
              Support the work of the Conventual Franciscan Friars and impact a life
            </h2>
            <p className="kf-donation-popup__lead">
              Your generosity helps us continue our mission of peace, justice, and charity across Kenya—from education and healthcare to pastoral care and community outreach.
            </p>
            <Link to="/donation" onClick={close}>
              <Button variant="gold" size="lg" className="kf-donation-popup__btn">
                Donate Now
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
